<script setup lang="ts">
import Button from 'primevue/button'
import FormatStatusMessage from '@/components/ui/FormatStatusMessage.vue'
import { useTranslation } from 'i18next-vue'

const { t } = useTranslation()
</script>

<template>
    <FormatStatusMessage
        severity="info"
        message="ui.profile.emailNotVerified"
        icon="pi pi-info-circle"
        :pt="{
            root: {
                class: 'rounded-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary',
            },
            content: { class: 'justify-center' },
        }"
    >
        <template #action>
            <Button
                :label="t('ui.profile.verifyEmailButton')"
                as="router-link"
                :to="{ name: 'verify-email' }"
                severity="info"
                data-testid="email-verification-banner-verify-link"
                class="h-9"
            />
        </template>
    </FormatStatusMessage>
</template>
